import { render, staticRenderFns } from "./link.vue?vue&type=template&id=5c1f56ce&fddApi"
import script from "./link.vue?vue&type=script&lang=js&fddApi"
export * from "./link.vue?vue&type=script&lang=js&fddApi"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports